import React, { useState, useEffect, useCallback } from 'react'
import "./quizItem.css"
import { useParams } from "react-router-dom";
import apiService from "../../services/ApiService";
import { toast } from "react-toastify";
import { Descriptions } from "antd";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);


const QuizItem = () => {

    const [item, setItem] = useState(null)
    const [isPopup, setIsPopup] = useState(false)
    const [loading, setLoading] = useState(true)
    const { id } = useParams();

    const handlePopup = (state) => setIsPopup(state)

    const getSingleItem = useCallback(async () => {
        if (!id) {
            toast.error("ID nije pronađen");
            setLoading(false);
            return;
        }

        setLoading(true);
        const [success, error] = await apiService.get(`quiz/participants/${id}`);

        if (error) {
            toast.error("Doslo je do greske, pokusajte malo kasnije");
            setLoading(false);
            return;
        }

        setItem(success?.data?.participant || null)
        setLoading(false);

    }, [id]);

    const buttonHandler = async () => {
        const [success, error] = await apiService.put(`quiz/participants/${id}`);

        if (error) {
            toast.error("Doslo je do greske, pokusajte malo kasnije");
            return;
        }

        handlePopup(false)

        setItem(success?.data?.participant)
    }


    const handleClose = (event) => {
        // Check if the clicked element is not the content div
        if (!event.target.closest('.content')) {
            handlePopup(false);  // Trigger the action only when clicking outside content
        }
    };


    useEffect(() => {
        if (id) {
            setItem(null); // Reset item when id changes
            getSingleItem();
        } else {
            setLoading(false);
        }
    }, [id, getSingleItem]);

    if (loading) {
        return (
            <div className='quizMain quizItem'>
                <div className='title'>Učitavanje...</div>
            </div>
        );
    }

    if (!item) {
        return (
            <div className='quizMain quizItem'>
                <div className='title'>Prijava nije pronađena</div>
            </div>
        );
    }

    return (
        <div className='quizMain quizItem'>


            {isPopup &&
                <div className='popup' onClick={handleClose}>
                    <div className='content' onClick={(e) => e.stopPropagation()}>
                        <div> <b>
                            {item?.isWinner ? "Da li ste sigurni da želite da uklonite ovog pobednika?" : "Da li ste sigurni da želite da označite ovu prijavu kao pobednika?"}

                        </b> </div>
                        <div className='winnerBtn' onClick={buttonHandler}> POTVRDI</div>
                    </div>
                </div>
            }


            <div className='title'>Detalji o ovoj prijavi</div>

            <Descriptions bordered
                column={1}
                className='custom-description'
                extra={
                    <div className={item.isWinner ? `winnerBtn greenBack` : 'winnerBtn'} onClick={() => handlePopup(true)}>

                        {item.isWinner ? "Ukloni pobednika" : "Označi kao pobednika"}
                    </div>
                }>

                <Descriptions.Item label="Email"> {item?.email} </Descriptions.Item>

                <Descriptions.Item label="Telefon">{item?.phone}</Descriptions.Item>

                <Descriptions.Item label="Tačni odgovori">{item?.correctAnswers}</Descriptions.Item>

                <Descriptions.Item label="Tekst">{item?.whyMe}</Descriptions.Item>

                <Descriptions.Item label="Vreme trajanja">{item?.quizTime ? `${item.quizTime / 1000}s` : '-'}</Descriptions.Item>

                <Descriptions.Item label="Datum prijave">{item?.createdAt ? dayjs(item.createdAt).format('D MMM YYYY') : '-'}</Descriptions.Item>

            </Descriptions>


        </div>
    )
}

export default QuizItem

